/* globals Mime */

/** @type {Record<string, Mime.Render>} */
const render = {
	video: 'custom',
	audio: 'custom',
	image: 'custom',
	office: 'custom',
	// pour les pdf, doit être "inline" sinon le viewer PDF de Chrome va télécharger avec le nom du blob...
	pdf: 'inline',
	html: 'custom',
	mail: 'custom',
	json: 'custom',
	text: 'custom',
	zip: 'custom',

	excel: 'none',
	default: 'none',
};

/** @type {any} */
const mime = {
	'video/mp4': 'video',
	'video/x-msvideo': 'video',
	'video/mpeg': 'video',
	'video/ogg': 'video',
	'video/webm': 'video',
	'video/x-matroska': 'video',

	'audio/aac': 'audio',
	'audio/midi': 'audio',
	'audio/x-midi': 'audio',
	'audio/mpeg': 'audio',
	'audio/ogg': 'audio',
	'audio/opus': 'audio',
	'audio/wav': 'audio',
	'audio/x-wav': 'audio',
	'audio/webm': 'audio',
	'audio/x-m4a': 'audio',

	'image/bmp': 'image',
	'image/gif': 'image',
	'image/heic': 'image',
	'image/heif': 'image',
	'image/jpeg': 'image',
	'image/jpg': 'image',
	'image/png': 'image',
	'image/svg+xml': 'image',
	'image/tiff': 'image',
	'image/vnd.microsoft.icon': 'image',
	'image/webp': 'image',

	'application/gzip': 'zip',
	'application/vnd.rar': 'zip',
	'application/x-7z-compressed': 'zip',
	'application/x-rar-compressed': 'zip',
	'application/x-zip-compressed': 'zip',
	'application/zip': 'zip',
	'multipart/x-zip': 'zip',

	'application/pdf': 'pdf',

	'application/json': 'json',
	'application/ld+json': 'json',

	'text/css': 'text',
	'text/csv': 'text',
	'text/html': 'html',
	'text/javascript': 'text',
	'text/plain': 'text',
	'text/xml': 'text',
	'application/x-httpd-php': 'text',
	'application/rtf': 'text',
	'application/xml': 'text',

	'application/vnd.ms-outlook': 'mail',
	'message/rfc822': 'mail',

	'application/clarisworks': 'office',
	'application/coreldraw': 'office',
	'application/macwriteii': 'office',
	'application/msword': 'office',
	'application/vnd.lotus-1-2-3': 'office',
	'application/vnd.ms-excel': 'office',
	'application/vnd.ms-excel.sheet.binary.macroEnabled.12': 'office',
	'application/vnd.ms-excel.sheet.macroEnabled.12': 'office',
	'application/vnd.ms-excel.template.macroEnabled.12': 'office',
	'application/vnd.ms-office': 'office',
	'application/vnd.ms-powerpoint': 'office',
	'application/vnd.ms-powerpoint.presentation.macroEnabled.12': 'office',
	'application/vnd.ms-powerpoint.template.macroEnabled.12': 'office',
	'application/vnd.ms-visio.drawing': 'office',
	'application/vnd.ms-word.document.macroEnabled.12': 'office',
	'application/vnd.ms-word.template.macroEnabled.12': 'office',
	'application/vnd.ms-works': 'office',
	'application/vnd.oasis.opendocument.chart': 'office',
	'application/vnd.oasis.opendocument.graphics': 'office',
	'application/vnd.oasis.opendocument.graphics-flat-xml': 'office',
	'application/vnd.oasis.opendocument.graphics-template': 'office',
	'application/vnd.oasis.opendocument.presentation': 'office',
	'application/vnd.oasis.opendocument.presentation-flat-xml': 'office',
	'application/vnd.oasis.opendocument.presentation-template': 'office',
	'application/vnd.oasis.opendocument.spreadsheet': 'office',
	'application/vnd.oasis.opendocument.spreadsheet-flat-xml': 'office',
	'application/vnd.oasis.opendocument.spreadsheet-template': 'office',
	'application/vnd.oasis.opendocument.text': 'office',
	'application/vnd.oasis.opendocument.text-flat-xml': 'office',
	'application/vnd.oasis.opendocument.text-master': 'office',
	'application/vnd.oasis.opendocument.text-master-template': 'office',
	'application/vnd.oasis.opendocument.text-template': 'office',
	'application/vnd.oasis.opendocument.text-web': 'office',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'office',
	'application/vnd.openxmlformats-officedocument.presentationml.slideshow': 'office',
	'application/vnd.openxmlformats-officedocument.presentationml.template': 'office',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'office',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'office',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'office',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.template': 'office',
	'application/vnd.sun.xml.calc': 'office',
	'application/vnd.sun.xml.calc.template': 'office',
	'application/vnd.sun.xml.chart': 'office',
	'application/vnd.sun.xml.draw': 'office',
	'application/vnd.sun.xml.draw.template': 'office',
	'application/vnd.sun.xml.impress': 'office',
	'application/vnd.sun.xml.impress.template': 'office',
	'application/vnd.sun.xml.writer': 'office',
	'application/vnd.sun.xml.writer.global': 'office',
	'application/vnd.sun.xml.writer.template': 'office',
	'application/vnd.visio': 'office',
	'application/vnd.visio2013': 'office',
	'application/vnd.wordperfect': 'office',
	'application/x-abiword': 'office',
	'application/x-aportisdoc': 'office',
	'application/x-dbase': 'office',
	'application/x-dif-document': 'office',
	'application/x-fictionbook+xml': 'office',
	'application/x-gnumeric': 'office',
	'application/x-hwp': 'office',
	'application/x-iwork-keynote-sffkey': 'office',
	'application/x-iwork-numbers-sffnumbers': 'office',
	'application/x-iwork-pages-sffpages': 'office',
	'application/x-mspublisher': 'office',
	'application/x-mswrite': 'office',
	'application/x-pagemaker': 'office',
	'application/x-sony-bbeb': 'office',
	'application/x-t602': 'office',
	'calc': 'office',
	'draw': 'office',
	'impress': 'office',
	'text/rtf': 'office',
	'text/spreadsheet': 'office',
	'writer': 'office',
	'writer-global': 'office',
	'writer-web': 'office',

	default: 'binary',
};

export const getRender = (/** @type {string} */ mimeType) => render[mimeType] ?? render.default;
export const getType = (/** @type {string} */ type) => mime[type] ?? mime.default;

export default mime;
